export default {
  // #region Super hero colors
  'superhero-yellow': '#fdde00',
  'superhero-orange': '#ee5600',
  'superhero-shadow': '#802600',
  // #endregion

  // #region Retro blues colors
  'red-retro': '#311222',
  'dark-blue-retro': '#0a58b2',
  'light-blue-retro': '#7eafe0',
  // #endregion

  // #region Retro purple colors
  'purple-retro-light': '#a82ebd',
  'purple-retro-dark': '#782daf',
  'purple-retro-shadow': '#7479c2',
  // #endregion

  // #region Pale pink colors
  'pale-pink-light': '#F0ECD9',
  'pale-pink-dark': '#dba1a6',
  'pale-pink-shadow': '#1b1d2f',
  // #endregion

  // #region Wavy blue colors
  'wavy-blue-fill': '#29abe2',
  'wavy-blue-shadow': '#0a1f6b',
  // #endregion
};
